import { createSelector } from 'reselect';
import { tableInitialState } from '../../App/Ducks/Table.duck';
export const PENSIOENBIJ_STATUS_ALL = 'all';
export const actionTypes = {
  EventsTable: '[PensioenbijEvents] EventsTable',
  ChangePage: '[PensioenbijEvents] change page',
  SetPageSize: '[PensioenbijEvents] set page size',
  SelectAllRows: '[PensioenbijEvents] select all rows',
  ToggleRow: '[PensioenbijEvents] select row',
  ApplyFilter: '[[PensioenbijEvents] EventsTable] Apply filter',
  SetSearchQuery: '[PensioenbijEvents] set search query',
} as const;
export const pensioenbijDuckInitialState = {
  ...tableInitialState,
  selectedRows: [] as string[],
  searchQuery: '' as string,
  filters: {
    status: PENSIOENBIJ_STATUS_ALL as string,
    employer: null as string | null,
    mutationType: null as string | null,
  },
};
export type PensioenbijDuckState = typeof pensioenbijDuckInitialState;
export const reducer = (state = pensioenbijDuckInitialState, action: Record<string, any>): PensioenbijDuckState => {
  switch (action.type) {
    case actionTypes.EventsTable:
      return {
        ...state,
      };
    case actionTypes.ChangePage:
      return {
        ...state,
        page: action.payload.page,
      };
    case actionTypes.SetPageSize:
      return {
        ...state,
        pageSize: action.payload.pageSize,
      };
    case actionTypes.ApplyFilter:
      return {
        ...state,
        page: 1,
        pageSize: state.pageSize,
        filters: {
          ...state.filters,
          ...action.payload,
        },
        selectedRows: [],
      };
    case actionTypes.SetSearchQuery:
      return {
        ...state,
        page: 1,
        searchQuery: action.payload.searchQuery,
      };
    case actionTypes.SelectAllRows:
      return {
        ...state,
        selectedRows: action.payload.ids,
      };
    case actionTypes.ToggleRow:
      return {
        ...state,
        selectedRows: !state.selectedRows.includes(action.payload.row)
          ? [...state.selectedRows, action.payload.row]
          : state.selectedRows.filter(row => row !== action.payload.row),
      };
    default:
      return state;
  }
};
export const actions = {
  applyFilter: (name: string, value: any) => {
    return {
      type: actionTypes.ApplyFilter,
      payload: {
        [name]: value,
      },
    };
  },
  setSearchQuery: (searchQuery: string) => {
    return {
      type: actionTypes.SetSearchQuery,
      payload: { searchQuery },
    };
  },
  changePage: (page: number) => {
    return {
      type: actionTypes.ChangePage,
      payload: {
        page,
      },
    };
  },
  setPageSize: (pageSize: number) => {
    return {
      type: actionTypes.SetPageSize,
      payload: {
        pageSize,
      },
    };
  },
  selectAllRows: (ids: string[]) => {
    return {
      type: actionTypes.SelectAllRows,
      payload: {
        ids,
      },
    };
  },
  toggleRow: (row: string) => {
    return {
      type: actionTypes.ToggleRow,
      payload: {
        row,
      },
    };
  },
};
export const selectors = {
  selectEventTables: createSelector(
    (state: PensioenbijDuckState) => state,
    eventTables => eventTables,
  ),
};
